import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api, { getGoogleMapsQr } from '../Base/Config';
import Message from '../Components/Message/Message';
import styles from './qr-details.module.css';

export default function LocationDetails(){
    const string = useParams().string;
    const [loader, setLoader] = useState(true);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        fetchFunction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchFunction = () => {
        api.get(getGoogleMapsQr + string)
        .then(res => {
            setLoader(false);
            if(res.data.code === 200) {
                window.location.replace(res.data.result);
            } else {
                console.log(res);
                setMessageType('error');
                setMessage(res.data.message);
            }
        })
        .catch(err => {
            setLoader(false);
            console.error(err);
            setMessageType('error');
            setMessage('Please try again, Sorry for the trouble.');
        })
    }

    return (<>
        {message && <Message type={messageType} message={message} closeMessage={() => setMessage('')} />}
        <div className={styles['loader']}>
            {
                loader
                ?<img src="../images/loader.gif" alt="loader" style={{width:'100px'}} />
                :"Success"
            }
        </div>
    </>)
}
